export default "__VITE_ASSET__Bm$2EhLM__"